import React from 'react'
import './TimeZone.css'
const TimeZone = () => {
  const getTimezone = () => {
    const wiviTimezone: string | null = localStorage.getItem('wivi.preferences')
        const tzLocation = wiviTimezone?.indexOf('val') ? wiviTimezone?.indexOf('val') : 1
        const endTZ = wiviTimezone?.indexOf(`\\"}`, tzLocation) ? wiviTimezone?.indexOf('\\"}', tzLocation) : 1
        const timezoneString =
          wiviTimezone === null ? '' : wiviTimezone?.substring(tzLocation + 8, endTZ)
    return timezoneString
  }
  return (
    <p className='navbar-text navbar-right'>
      <a href='/ui/#!/account'>{getTimezone()}</a>
    </p>
  )
}

export default TimeZone
